<template>
  <div class="form-box">
    <el-form
      ref="form"
      :hide-required-asterisk="true"
      label-position="top"
      :rules="rules"
      label-width="200px"
      :model="form"
    >
      <el-form-item
        prop="code"
        :rules="[
          {
            required: true,
            message: '請輸入推廣碼',
            trigger: 'blur',
          },
        ]"
      >
        <div slot="label">
          <div class="label-text">
            推廣碼
            <span class="star-mark">*</span>
          </div>
        </div>
        <el-input
          v-model="form.code"
          placeholder="請輸入推廣碼"
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>

      <el-form-item>
        <div slot="label">
          <div class="label-text">描述</div>
        </div>
        <el-input
          type="textarea"
          :rows="6"
          v-model="form.description"
          placeholder="描述"
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        prop="discount"
        :rules="[
          {
            required: true,
            message: '請輸入折扣',
            trigger: 'blur',
          },
          {
            message: '請輸入纯數字',
            //請輸入纯數字正则
            pattern: /^[0-9]*$/,
            trigger: 'blur',
          },
        ]"
      >
        <div slot="label">
          <div slot="label">
            <div class="label-text">
              折扣
              <span class="star-mark">*</span>
            </div>
          </div>
        </div>
        <el-input
          v-model.number="form.discount"
          placeholder="請輸入折扣"
          class="fixed-with-330-input"
        >
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getRoles } from "@/api/users";
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {
      roles: [],
      statuses: [],
      rules: {},
    };
  },
  created() {
    this.getRoles();
  },
  methods: {
    getRoles() {
      getRoles().then((v) => {
        this.roles = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-box {
  overflow: hidden;
}

.label-text {
  font-size: 20px;
  line-height: 24px;
}

::v-deep {
  .el-input__inner {
    height: 53px;
  }
  .el-select {
    width: 330px;
  }
}

.fixed-with-330-input {
  width: 330px;
}

.fixed-with-141-input {
  width: 141px;
}

::v-deep {
  .el-form-item__content {
    line-height: 24px;
  }
}
.submitButton {
  width: 150px;
  margin-top: 10px;
}
</style>